import React from "react";
import cx from "classnames";
import t from "Utils/translation";
import s from "./input.scss";
import { Icon, eye, eyeNot } from "Icons/index";
const zxcvbn = require("zxcvbn");

const isAuthField = (name) => {
  if (name === "email") return true;
  if (name === "email_address") return true;
  if (name === "password") return true;
  if (name === "password_confirmation") return true;
  return false;
};

export default class Input extends React.Component {
  state = {
    passwordScore: 0,
    isAuthField: false,
    showPassword: false,
  };

  componentDidMount() {
    this.setState({ isAuthField: isAuthField(this.props.name) });
  }

  updateValue = (e) => {
    let value = this.props.type === "number" ? parseInt(e.currentTarget.value) : e.currentTarget.value;

    if (this.props.onChange) {
      if (this.props.trim) value = value ? value.trim() : value;
      this.props.onChange({ [this.props.name]: value });
    }
  };

  focus() {
    this.input.focus();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value && this.props.showPasswordScore) {
      this.calcPasswordScore(this.props.value);
    }
  }

  calcPasswordScore = (value) => {
    const { score } = zxcvbn(value);
    this.setState({ passwordScore: score });
  };

  render() {
    let {
      name,
      label,
      id,
      type,
      hint,
      required,
      disabled,
      min,
      max,
      onBlur,
      onFocus,
      maxLength,
      step,
      placeholder,
      value,
      errors,
      autoComplete,
      autoCapitalize,
      icon,
      noRequired = false,
      className,
      inline = false,
      blockedTextEnd,
      blockedTextStart,
      helpTooltip,
      onKeyDown,
      showPasswordScore,
      wrapperClassName,
      isVianova,
    } = this.props;

    const { passwordScore } = this.state;

    let placeholderString;
    if (type === "password" && !placeholder) {
      placeholderString = t("input.placeholder.pwdRules");
    } else if (placeholder) {
      placeholderString = placeholder;
    } else {
      placeholderString = name ? name.replace(/_/g, " ") : "";
    }

    let style = { background: "none" };
    let checkLabel = "";

    if (type === "password" && passwordScore) {
      checkLabel = t("input.hint.passwordScore.check");

      if (passwordScore === 0) {
        style = { gridColumn: "1 / 2", background: "var(--red)" };
        checkLabel = t("input.hint.passwordScore.poor");
      } else if (passwordScore === 1) {
        style = { gridColumn: "1 / 3", background: "var(--orange)" };
        checkLabel = t("input.hint.passwordScore.easy");
      } else if (passwordScore === 2) {
        style = { gridColumn: "1 / 4", background: "var(--yellow)" };
        checkLabel = t("input.hint.passwordScore.weak");
      } else if (passwordScore === 3) {
        style = { gridColumn: "1 / 5", background: "var(--lime)" };
        checkLabel = t("input.hint.passwordScore.strong");
      } else if (passwordScore === 4) {
        style = { gridColumn: "1 / 6", background: "var(--green)" };
        checkLabel = t("input.hint.passwordScore.great");
      }
    }

    return (
      <div
        className={cx(s.inputContainer, className, {
          [s.withErrors]: errors,
          [s.withBlockedTextEnd]: blockedTextEnd,
          [s.withBlockedTextStart]: blockedTextStart,
          [s.labelInRow]: inline,
          [s.labelHint]: hint,
          [s.required]: required && !noRequired,
          [s.disabled]: disabled,
        })}
      >
        {(label || helpTooltip || hint) && (
          <div className={s.wrapLabel}>
            <label className={cx(s.label, { [s.vianovaLabel]: isVianova })} htmlFor={id}>
              {label || name.replace(/_/g, " ")}
            </label>

            {helpTooltip && <div className={s.helpTooltip}>{helpTooltip}</div>}

            {hint && <div className={s.hint}>{hint}</div>}
          </div>
        )}
        <div className={cx(s.wrapInput, wrapperClassName)}>
          {blockedTextStart && (
            <div className={s.wrapBlockedTextStart}>
              <span className={s.blockedTextStart}>{blockedTextStart}</span>
            </div>
          )}

          <input
            className={cx(s.input, { [s.vianovaInput]: isVianova })}
            ref={(input) => {
              this.input = input;
            }}
            id={id}
            type={this.state.showPassword ? "text" : type}
            name={name}
            required={required}
            disabled={disabled}
            onFocus={onFocus}
            onChange={this.updateValue}
            value={value ? value : value === 0 ? 0 : ""}
            min={min && parseInt(min)}
            max={max && parseInt(max)}
            maxLength={maxLength}
            step={step}
            placeholder={placeholderString}
            autoComplete={autoComplete}
            autoCapitalize={autoCapitalize}
            onKeyDown={onKeyDown}
            {...(this.state.isAuthField ? {} : { "data-1p-ignore": true })}
            onBlur={onBlur}
          />

          {type === "password" && (
            <Icon
              className="absolute -translate-y-1/2 right-[9px] top-1/2"
              svg={this.state.showPassword ? eyeNot : eye}
              width="0.875rem"
              onClick={() => this.setState({ showPassword: !this.state.showPassword })}
            />
          )}
          {icon && <Icon className="absolute -translate-y-1/2 right-2 top-1/2" svg={icon} width="1rem" />}
          {blockedTextEnd && (
            <div className={s.wrapBlockedTextEnd}>
              <span className={s.blockedTextEnd}>{blockedTextEnd}</span>
            </div>
          )}
        </div>

        {type === "password" && showPasswordScore && (
          <div className={s.passwordScore}>
            <div className={s.progress}>
              <div className={s.progressBar} style={style} />
            </div>
            <div className={s.progressLabel}>{checkLabel}</div>
          </div>
        )}

        {errors && <div className={s.errorMsg}>{errors}</div>}
      </div>
    );
  }
}
